import { Injectable } from '@angular/core';

@Injectable()
export class ChartsService {
	type: string;

	constructor() {}

	getChartPointsInPercents(type = 'doughnutChartType') {
		switch (type) {
			case 'doughnutChartType': {
				return {
					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								const label = data.labels[tooltipItem.index] || '';
								const sumArr = data.datasets[0].data.reduce((accumulator, currentValue) => accumulator + currentValue);
								const hoveredItem = data.datasets[0].data[tooltipItem.index];
								let percents = (hoveredItem / sumArr) * 100;

								if (percents < 2 && data.datasets[0].data.length <= 3) {
									percents = Math.floor(percents);
								} else {
									percents = Math.round(percents);
								}

								return `${label}: ${percents}%`;
							}
						}
					}
				};
			}

			default: {
				break;
			}
		}
	}
}
